module.exports = __webpack_public_path__ + "static/media/chalala-01.723ddc62.svg";